import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/photos/info.svg'
import _imports_1 from '@/assets/photos/album.svg'
import _imports_2 from '@/assets/photos/download.svg'
import _imports_3 from '@/assets/photos/loading.svg'
import _imports_4 from '@/assets/photos/trashBin.svg'
import _imports_5 from '@/assets/photos/download1.svg'
import _imports_6 from '@/assets/chat/empty-img-default.svg'
import _imports_7 from '@/assets/photos/arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-f5072180"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photo" }
const _hoisted_2 = {
  key: 0,
  class: "headerInfo"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "photoBox" }
const _hoisted_5 = { class: "photosTop" }
const _hoisted_6 = { class: "middleTags" }
const _hoisted_7 = {
  key: 0,
  class: "albumTags"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "pointer"
}, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "changeTags"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_11 = {
  class: "buttomItem pointer",
  style: {"margin-right":"16px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"padding":"0px 14px"},
  class: "custom-loading"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "",
    class: "circular"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_15 = {
  key: 1,
  class: "rightButtom"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_17 = {
  class: "buttomItem pointer",
  style: {"margin-right":"16px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"padding":"0px 14px"},
  class: "custom-loading"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "",
    class: "circular"
  })
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_21 = { class: "photoMiddle" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  id: "contentsBox",
  class: "contentsBox"
}
const _hoisted_24 = { class: "sectionBox" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "photoCheckBox checkboxDiv" }
const _hoisted_27 = { class: "photoContents" }
const _hoisted_28 = { class: "photoItem pointer" }
const _hoisted_29 = { class: "checkboxDiv" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "sectionBox" }
const _hoisted_32 = { class: "albumContents" }
const _hoisted_33 = { class: "albumItem" }
const _hoisted_34 = { class: "albumImg" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "albumName" }
const _hoisted_37 = { class: "albumNum" }
const _hoisted_38 = {
  key: 2,
  class: "empty"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_40 = { class: "empty-text" }
const _hoisted_41 = { class: "pagination" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_43 = { class: "paginationBox" }

import { ref, computed, onMounted, Ref, watch, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { photoInfo, deletePhoto, syncIOSPhotosApi, iosPhotosApi } from "@/api/devices";
import publicHeader from '@/components/publicHeader/publicHeader.vue'
// import { getFileLinkByKey } from '@/utils/fileOperate'
import { isImageOrVideo } from "@/utils/format";
import { getFileLinkApi } from '@/api/chat/index';
import { dateFormat, dateFormatAm } from "@/utils/format";
import { downloadFile, downloadFileMore, downloadDemoFile, downloadDemoFileMore } from "@/utils/downloadFile";
import JSZip from 'jszip';
import noticeDialog from "@/components/homePage/tabItem/noticeDialog.vue";
import loading from "@/components/chat/loading.vue";
import { ElMessage } from "element-plus";
import moment from "moment";
import changeCancel from "@/components/homePage/tabItem/changeCancel.vue";
import { getQueryParam, gaEvent } from "@/utils/format";
import FileSaver from "file-saver"
import Tooltip from "@/components/common/tooltip.vue";
import { useRouter } from "vue-router";
import { jsonData, jsonData1, jsonData2, jsonData3, jsonData4, previewImgListJson } from '@/mock/photos.js'


interface PhotoItem {
  // 根据实际情况定义 PhotoItem 的属性
  date: string;
  // ... 其他属性
}

export default /*#__PURE__*/_defineComponent({
  __name: 'photos',
  emits: ['updateHeaderDate'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const Emits = __emit
const isVibe = computed(() => !store.state.isVibe);
const store = useStore();
let router = useRouter();
const selectedTagName = ref(1)//当前选中的tags 1照片2文件夹
const selectedArray = ref([])//所有选中的相片
const showUpdateTime = ref(false) //是否展示更新时间
let lastUpdateTime = ref(0)// 最后更新时间
const showRightBox = ref(true) //是否展示时间筛选
let startTime = ref('')// 开始时间
let endTime = ref('')//结束时间
const currentPage = ref(1) // 当前的页数
const albumList = ref([]) //文件夹的数组
const albumCurrName = ref('')//当前文件夹的名称
const albumPhoto = ref(false) //文件夹中的图片
const isShowDia = ref(false)//是否展示弹窗
const previewImgList = ref([])//预览的照片数组
const currentPreviewIndex = ref(0);//预览第几张图片
const photoLoading = ref(false);//图片loading
const totalNum = ref(0) //总数量
const albumName = ref('')//文件夹名称
const isFirst = ref(false) //是否第一次进来
const downloadLoading = ref(false) //下载的loading
const appId = computed(() => store.state.currentDeviceInfo.apple_id); //apple_id
const isExpired = computed(() => store.state.currentDeviceInfo.is_expired); //apple_id
const photoListArray: Ref<PhotoItem[][]> = ref([]);//图片数组
const isAllSelect = computed(() => {//是否全选
  console.log("computed:", selectedArray.value.length, previewImgList.value.length);

  return (selectedArray.value.length == previewImgList.value.length) && selectedArray.value.length > 0
})
const deviceId = computed(() => {//设备id
  return store.state.currentDeviceInfo.id;
});
const deviceType = computed(() => {//设备id
  return store.state.deviceType;
});
const messageToastType = computed(() => store.state.messageToastType);
const isShowMore750 = computed(() => store.state.isShowMore750);//是否大于750


//获取信息
const getPhotoList = async (name?: string, isSync?: boolean) => {
  console.log('device_id', deviceId.value);
  console.log('showRightBox.value', showRightBox.value);
  console.log('name', name);
  photoListArray.value = []
  photoLoading.value = true
  let typeC;//1:照片 2:文件夹
  if (selectedTagName.value == 1 || (selectedTagName.value == 2 && albumPhoto.value)) {
    typeC = 1
  } else if (selectedTagName.value == 2 && !albumPhoto.value) {
    typeC = 2
  }
  let params = {} as {
    device_id?: any;
    page: number;
    type?: any;
    start_date?: any;
    end_date?: any;
    album_name?: any;
    apple_id?: any; // 添加了可选的 apple_id 属性
  }
  if (!isVibe.value) {
    console.log("././././././././");
    if (selectedTagName.value == 2 && albumPhoto) name = albumName.value
    console.log("selectedTagName.value == 2 && albumPhoto:", selectedTagName.value == 2 && albumPhoto.value);
    console.log("name:", name);
    params = {
      device_id: deviceId.value,
      type: typeC,
      start_date: showRightBox.value ? startTime.value : 1609430400,
      end_date: showRightBox.value ? endTime.value : moment().add(12, "M").format("X"),
      page: currentPage.value,
      album_name: name ? name : ''
    }
  } else {
    gaEvent("Photo_interface", {
      event_category: "Photo",
      event_label: '1ms',
    });
    showUpdateTime.value = true
    lastUpdateTime.value = jsonData.update_time
    photoListArray.value = jsonData.data
    previewImgList.value = previewImgListJson
    console.log("previewImgList:", previewImgList.value);
    photoLoading.value = false
    if (isFirst.value) return
    gaEvent("Photo_PV", {
      event_category: "Photo",
      event_label: 'Data',
    });
    isFirst.value = true
    gaEvent("Photo_Show", {
      event_category: "Photo",
      event_label: '1ms',
    });
    return
  }
  // if (deviceType.value && albumPhoto.value) {
  //   // params.apple_id = appId.value
  //   // delete params.device_id; // 删除 device_id 属性
  //   params = {
  //     page: currentPage.value,
  //   }
  // }
  const chatListSourceRef = computed(() => store.state.photoInfoSource);
  console.log("chatListSourceRef:", chatListSourceRef.value);
  console.log("params:", params);

  // 取消掉上一次请求
  chatListSourceRef.value &&
    chatListSourceRef.value.cancel("请勿频繁请求会话列表接口");
  let photoApi: any = photoInfo
  if (deviceType.value) {
    console.log("deviceType.valuedeviceType.value:", deviceType.value);

    if (selectedTagName.value == 1 && !isExpired.value && !isVibe.value) {
      photoApi = iosPhotosApi
      params = {
        page: currentPage.value,
      }
    } else {
      params.apple_id = appId.value
      params.album_name = params.album_name ? params.album_name : (isVibe.value ? '' : 'system-album-1')
      delete params.device_id; // 删除 device_id 属性
    }

  }
  console.log("到底调的啥:", deviceType.value && selectedTagName.value == 1, typeC);
  //只有ios查看全部照片的时候才调这个接口
  if (deviceType.value && selectedTagName.value == 1 && !isVibe.value && !isExpired.value) photoApi = iosPhotosApi
  if (typeC == 2) {
    if (params.start_date) {
      delete params.start_date
      delete params.end_date
    }
  }
  let gaStartime = new Date().getTime()
  photoApi(params, appId.value)
    .then(async (res: any) => {
      console.log("res:::", res);
      let updateTime = ((new Date().getTime() - gaStartime))
      gaEvent("Photo_interface", {
        event_category: "Photo",
        event_label: updateTime + 'ms',
      });
      console.log("updateTime:", updateTime);
      photoListArray.value = []
      selectedArray.value = []
      previewImgList.value = []
      // albumList.value = []
      let data = res.data.data
      if (!data.elements) {
        photoLoading.value = false
        return
      }
      let onePageList = data.elements;
      console.log("deviceType.value && selectedTagName.value == 2 && !albumPhoto && onePageList[0].type == 1:", deviceType.value, selectedTagName.value == 2, !albumPhoto.value, onePageList[0].type == 1);

      if (deviceType.value && selectedTagName.value == 2 && !albumPhoto.value && onePageList[0].type == 1) return
      if (!isSync) {
        lastUpdateTime.value = data.update_time
        if (lastUpdateTime.value) {
          showUpdateTime.value = true
        } else {
          showUpdateTime.value = false
        }
      }
      totalNum.value = data.total
      if (isSync) {
        if (lastUpdateTime.value == data.update_time) {
          ElMessage({
            message: t("famikeep200['Synchronization successful, no new data']"),
            type: "success",
          });
        } else {
          ElMessage({
            message: t("chat.syncSuccessed"),
            type: "success",
          });
        }
        lastUpdateTime.value = data.update_time
        if (lastUpdateTime.value) {
          showUpdateTime.value = true
        } else {
          showUpdateTime.value = false
        }
        // } else {
        //   showUpdateTime.value = false
        // }
        gaEvent("Photo_Sync", {
          event_category: "Photo",
          event_label: 'Success',
        });
      }
      if (onePageList && onePageList.length > 0 && (selectedTagName.value == 1 || albumPhoto.value)) {
        const onePageListPromise = onePageList.map(
          async (item: any, index: any) => {
            // const fileURL = await getFileLinkByKey(item.oss_key);
            const dateYMD = isVibe.value ? dateFormatAm(item.date, "YYYY-MM-DD") : dateFormat(item.date, "YYYY-MM-DD");
            return {
              ...item,
              // file_url: fileURL,
              dateYMD: dateYMD,
              isSelect: false
            };
          }
        );
        onePageList = await Promise.all(onePageListPromise);
        console.log("onePageList:", onePageList);
        const photoList = new Map();
        onePageList.forEach((item: any) => {
          const date = item.dateYMD;
          if (!photoList.has(date)) {
            photoList.set(date, []);
          }
          photoList.get(date).push(item);
        });
        photoListArray.value = Array.from(photoList.entries())
          .map(([date, items]) => {
            console.log("items:", items);
            if (items && items.length > 0) {
              items.forEach((item: any) => {
                // console.log("item:", item);

                previewImgList.value.push(item.thumb_url ? item.thumb_url : item.origin_url)
              })
            }
            const year = dateFormat(date, "YYYY-MM-DD");
            const isAllDaySelect = false
            return [year, isAllDaySelect, items];
          })
        console.log("photoList:", photoList);
        console.log("photoListArray:", photoListArray);
      } else if (onePageList && onePageList.length > 0 && selectedTagName.value == 2) {
        albumList.value = onePageList
        if (deviceType.value) {
          albumList.value.forEach((item: any) => {
            if (item.name == "system-album-1") {
              item.iosname = t("famikeep210.Gallery")
            } else if (item.name == "system-album-2") {
              item.iosname = t("famikeep210.Recent Projects")
            } else if (item.name == "system-album-3") {
              item.iosname = t("famikeep210.Personal Collection")
            } else if (item.name == "system-album-4") {
              item.iosname = t("famikeep210.Recently Deleted")
            } else if (item.name == "system-album-5") {
              item.iosname = t("famikeep210.Video")
            } else if (item.name == "system-album-6") {
              item.iosname = t("famikeep210.Live Photos")
            } else if (item.name == "system-album-7") {
              item.iosname = t("famikeep210.Exposure Photos")
            } else if (item.name == "system-album-8") {
              item.iosname = t("famikeep210.Panoramic Photos")
            } else if (item.name == "system-album-9") {
              item.iosname = t("famikeep210.Time-Lapse Photography")
            } else if (item.name == "system-album-10") {
              item.iosname = t("famikeep210.Slow Motion")
            } else if (item.name == "system-album-11") {
              item.iosname = t("famikeep210.Portrait")
            } else if (item.name == "system-album-12") {
              item.iosname = t("famikeep210.Burst Mode")
            } else if (item.name == "system-album-13") {
              item.iosname = t("famikeep210.Screenshot")
            } else if (item.name == "system-album-14") {
              item.iosname = t("famikeep210.Motion")
            } else if (item.name == "system-album-15") {
              item.iosname = t("famikeep210.Hide")
            }
          })
        }
      }
      photoLoading.value = false
      console.log("是否第一次进入：", isFirst.value);
      if (isFirst.value) return
      gaEvent("Photo_PV", {
        event_category: "Photo",
        event_label: onePageList && onePageList.length > 0 ? 'Data' : 'NoData',
      });
      isFirst.value = true
      let updateTime1 = ((new Date().getTime() - gaStartime))
      console.log("updateTime1:", updateTime1);
      gaEvent("Photo_Show", {
        event_category: "Photo",
        event_label: updateTime1 + 'ms',
      });
      // console.log("previewImgList:", previewImgList.value);
    })
    .catch((err: any) => {
      console.log("err:::", err);
      photoLoading.value = false
      if (isSync) {
        gaEvent("Photo_Sync", {
          event_category: "Photo",
          event_label: 'Fail',
        });
        ElMessage({
          message: t("chat.syncFailed"),
          type: "error",
        });
      }
    })
    .finally(() => {
      setTimeout(() => {
        store.commit("setSyncLoading", false);
      })
    })
}
//接收到的时间
const updateHeaderDate = (value: any) => {
  startTime.value = value[0]
  endTime.value = value[1]
  console.log("444444444444444");
  console.log("selectedTagName.value:", selectedTagName.value);
  // albumName
  if (selectedTagName.value == 2 && albumPhoto.value) {
    getPhotoList(albumName.value)
  } else {
    getPhotoList()
  }
  console.log('接收到的时间：', startTime.value, endTime.value);
};
//切换头部选项卡
const clickChangeTags = (val: number) => {
  if (albumPhoto.value) return
  if (isVibe.value) {
    if (val == 1) {
      selectedTagName.value = 1
      lastUpdateTime.value = jsonData.update_time
      photoListArray.value = jsonData.data
    } else {
      selectedTagName.value = 2
      showRightBox.value = false
      albumList.value = jsonData1.data.elements
    }
    return
  }
  if (val == 1) {
    selectedTagName.value = 1
    if (deviceType.value) {
      showRightBox.value = false
    } else {
      showRightBox.value = true
    }

  } else {
    selectedTagName.value = 2
    showRightBox.value = false
  }
  currentPage.value = 1
  albumPhoto.value = false
  console.log("55555555555555555555");

  if (selectedTagName.value == 2 || isExpired) {
    console.log("999999999999");

    getPhotoList()
  }
  // getPhotoList()
  console.log(selectedTagName.value);
}
// 根据oos_key获取对应的文件下载地址
const getFileLinkByKey = async (oss_key: any) => {
  const data = {
    oss_key: oss_key,
  };
  try {
    const res = await getFileLinkApi(data);
    // console.log(res, 'getFileLinkByKey');
    if (res.data.code == 200) {
      const fileURL = res.data.data.url;
      return new Promise((resolve, reject) => {
        resolve(fileURL);
      });
    }
  } catch (err) {
    console.log(err);
  }
};
//当天时间的全选
const selectDayAll = (list: any) => {
  console.log("list:", list);

  if (list[1]) {
    list[2].map((item: any) => {
      item.isSelect = true
      if (selectedArray.value.includes(item)) return
      selectedArray.value.push(item)
    })
    console.log("selectedArrayA:", selectedArray.value);

  } else {
    list[2].map((item: any) => {
      item.isSelect = false
      let deleteId = selectedArray.value.findIndex((element) => element.id == item.id)
      selectedArray.value.splice(deleteId, 1)
      console.log("aa:", deleteId);
    })
    console.log("selectedArrayAll:", selectedArray.value);

  }

}
//当前页面全选
const selectAllClick = () => {
  if (isAllSelect.value) {
    photoListArray.value.forEach((element: any) => {
      element[1] = false
      element[2].forEach((item: any) => {
        item.isSelect = false
      });
    });
    selectedArray.value = [];

  } else {
    selectedArray.value = [];

    // Assuming you have an array of all items
    photoListArray.value.forEach((element: any) => {
      element[1] = true
      element[2].forEach((item: any) => {
        item.isSelect = true
        selectedArray.value.push(item)
      });
    });
    console.log("selectedArray:", selectedArray.value);

  }
}
//选中当前相片
const changeCheckBoxStaus = (item: any, photoList: any) => {
  console.log("eeee:", item);
  if (item.isSelect) {
    selectedArray.value.push(item)
  } else {
    console.log("item.id:", item.id);
    selectedArray.value = selectedArray.value.filter((obj: any) => {
      return item.id != obj.id
    })
    console.log("selectedArray.value:", selectedArray.value);

  }
  console.log("selectedArray:", selectedArray.value);

  let dayPhotoList = photoList[2].filter((item: any) => item.isSelect)
  if (dayPhotoList.length == photoList[2].length) {
    photoList[1] = true
  } else {
    photoList[1] = false
  }
  console.log("select.length:", selectedArray.value.length);
  console.log("dayPhotoList.length:", dayPhotoList.length, photoList[2].length);
}
//分页
const handleSizeChange = (e: any) => {
  console.log("handleSizeChange:", e);
  currentPage.value = e
  console.log("666666666666666");

  getPhotoList()
}
const handleCurrentChange = (e: any) => {
  console.log("handleCurrentChange:", e);
  currentPage.value = e
  console.log("777777777777777777777");
  if (selectedTagName.value == 2 && albumPhoto.value) {
    getPhotoList(albumName.value)
  } else {
    getPhotoList()
  }
}
//文件夹图片
const goAlbumPhoto = (item: any) => {
  albumPhoto.value = true
  albumCurrName.value = item.iosname ? item.iosname : item.name
  showRightBox.value = true
  console.log("8888888888888888888888");
  albumName.value = item.name
  currentPage.value = 1
  if (isVibe.value) {
    console.log(item.name);
    if (item.name == 'Cute') {
      photoListArray.value = jsonData2.data
    } else if (item.name == 'Fun') {
      photoListArray.value = jsonData3.data
    } else {
      photoListArray.value = jsonData4.data
    }
    // getPhotoList(item.name)
  }
}
//返回文件夹
const goBackAlbum = () => {
  albumPhoto.value = false
  showRightBox.value = false
}
// 修改预览的index
const openPreview = (fileUrl: string) => {
  console.log("fileUrl:", fileUrl);
  currentPreviewIndex.value = previewImgList.value.findIndex((element) => element == fileUrl)
  // console.log("index:", index);

};
//下载文件
const downloadItem = async (url: any) => {
  let filename = url.split('?')
  filename = filename[0].split('.')
  let format = filename[filename.length - 1]
  if (!window.navigator.onLine) {
    ElMessage({
      message: t("networkAbnormaled"),
      type: "error",
    });
  } else {
    console.log("下载开始了");
    gaEvent("Photo_Download", {
      event_category: "Photo",
      event_label: 1,
    });

    try {
      if (isVibe.value) {
        await downloadDemoFile(url, 'Parentalguard.' + format, (downLoadProgress: any) => { });
      } else {
        await downloadFile(url, 'Parentalguard.' + format, (downLoadProgress: any) => { });
      }
    } catch (err) {
      console.log(err);
    }

    downloadLoading.value = false

  }

};
const boldArr = ref([])
//下载多文件
const downloadZip = async () => {
  const zip = new JSZip()

  boldArr.value = []
  downloadLoading.value = true
  console.log("selectedArray.value:", selectedArray.value);
  if (!window.navigator.onLine) {
    ElMessage({
      message: t("networkAbnormaled"),
      type: "error",
    });
  } else {
    if (selectedArray.value.length == 1) {
      downloadItem(selectedArray.value[0].download_url ? selectedArray.value[0].download_url : selectedArray.value[0].origin_url)
      return
    }
    // eslint-disable-next-line no-async-promise-executor
    return new Promise<any>(async (resolve, reject) => {
      for (let i = 0; i < selectedArray.value.length; i++) {
        let fileBold: any
        if (isVibe.value) {
          fileBold = await downloadDemoFileMore(selectedArray.value[i].download_url, (downLoadProgress: any) => { });
        } else {
          fileBold = await downloadFileMore(selectedArray.value[i].origin_url, (downLoadProgress: any) => { });
        }
        // const fileBold: any = await getFile(selectedArray.value[i].file_url)
        boldArr.value.push(fileBold)
        let filename = selectedArray.value[i].origin_url.split('?')
        filename = filename[0].split('.')
        let format = filename[filename.length - 1]
        zip.file(selectedArray.value[i].id + '.' + format, fileBold, { binary: true }) // 逐个添加文件
      }
      console.log("boldArr.length:", boldArr.value);
      console.log("boldArr.value.length === selectedArray.value.length", boldArr.value.length, selectedArray.value.length);
      // return
      if (boldArr.value.length === selectedArray.value.length) {
        try {
          zip.generateAsync({ type: "blob" }).then((content) => {
            // 生成二进制流
            FileSaver.saveAs(content, 'Parentalguard')
            gaEvent("Photo_Download", {
              event_category: "Photo",
              event_label: boldArr.value.length,
            });
            downloadLoading.value = false

            console.log("????");

            resolve(true)
          })
        } catch {
          reject(false)
          downloadLoading.value = false
        }
      } else {
        reject(false)
        downloadLoading.value = false
      }
    })
  }

}
//删除图片
const deletePhotoFun = () => {
  let temArray = selectedArray.value.map((item) => item.id)
  gaEvent("Photo_Delete", {
    event_category: "Photo",
    event_label: temArray.length,
  });
  console.log("temArray:", temArray);
  let params = {
    device_id: deviceId.value,
    ids: temArray
  }
  deletePhoto(params)
    .then(async (res) => {
      console.log("res:::", res);
      isShowDia.value = false
      getPhotoList()
    })
    .catch((err) => {
      console.log("err:::", err);
    })

}
// 五分钟定时更新
let closeFiveM: any
if (!deviceType.value && !isVibe.value) {
  closeFiveM = setInterval(() => {
    currentPage.value = 1
    console.log("33333333333333");
    albumName.value = ''
    selectedTagName.value = 1
    albumPhoto.value = false
    console.log("9999999999999999999");
    getPhotoList()
  }, 1000 * 60 * 5);
}

watch(deviceId, async () => {
  currentPage.value = 1
  console.log("33333333333333");
  albumName.value = ''
  selectedTagName.value = 1
  albumPhoto.value = false
  await getPhotoList()


  setTimeout(() => {
    console.log("previewImgList:", previewImgList.value.length);
    gaEvent("Photo_PV", {
      event_category: "Photo",
      event_label: previewImgList.value.length > 0 ? 'Data' : 'NoData',
    });
  }, 500);
  if (!isVibe.value && !deviceType.value) {
    clearInterval(closeFiveM);
    setNewInterval()
  }
})
// 设置新的定时器
const setNewInterval = () => {
  closeFiveM = setInterval(() => {
    currentPage.value = 1
    console.log("33333333333333");
    albumName.value = ''
    selectedTagName.value = 1
    albumPhoto.value = false
    console.log("2222222222222");

    getPhotoList()
  }, 1000 * 60 * 5);
}
const updateInfo = async () => {
  if (isVibe.value) {
    store.commit("setSyncLoading", false);
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  }

  if (deviceType.value) {
    let params = {
      apple_id: appId.value
    }
    try {
      let res = await syncIOSPhotosApi(params);
      console.log("res:", res);
      if (res.data.sync_status == 'syncing') {
        ElMessage({
          message: t("chat.syncSuccessed"),
          type: "success",
        });
        return
      } else if (res.status != 200) {
        store.commit("setSyncLoading", false);
        ElMessage({
          message: t("chat.syncFailed"),
          type: "error",
        });
        return
      }
      currentPage.value = 1
      getPhotoList('', true)
    } catch (err: any) {

    }
  } else {
    currentPage.value = 1
    getPhotoList('', true)
  }
}
onMounted(() => {
  if (isVibe.value) {
    currentPage.value = 1
    getPhotoList()
  }

  if (deviceType.value && selectedTagName.value == 1) showRightBox.value = false
})
onUnmounted(() => {
  clearInterval(closeFiveM);
})

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(publicHeader, {
      headerName: _ctx.$t('famikeep200.Photos'),
      headerSyncDate: _unref(lastUpdateTime),
      headerSelectData: [],
      onUpdateHeaderDate: updateHeaderDate,
      onUpdateInfo: updateInfo,
      showUpdateTime: showUpdateTime.value,
      showRightBox: showRightBox.value
    }, {
      headerInfo: _withCtx(() => [
        (!deviceType.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("famikeep200.Please note that photos")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["headerName", "headerSyncDate", "showUpdateTime", "showRightBox"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["left-select checkboxDiv", selectedTagName.value == 1 || (selectedTagName.value == 2 && albumPhoto.value) ? '' : 'opacityDiv'])
        }, [
          _createVNode(_component_el_checkbox, {
            class: "checkBox",
            modelValue: isAllSelect.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isAllSelect).value = $event)),
            onChange: selectAllClick
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("famikeep200.Select all photos on the current page")), 1)
        ], 2),
        _createElementVNode("div", _hoisted_6, [
          (selectedTagName.value == 2 && albumPhoto.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(albumCurrName.value), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass(["tagsItem pointer", selectedTagName.value == 1 ? 'selectedTags' : '']),
                  style: {"margin":"0 4px"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (clickChangeTags(1)))
                }, _toDisplayString(_ctx.$t('famikeep200.Photos')), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["tagsItem pointer", selectedTagName.value == 2 ? 'selectedTags' : '']),
                  style: {"margin-right":"4px"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (clickChangeTags(2)))
                }, _toDisplayString(_ctx.$t('famikeep200.Album')), 3)
              ]))
        ]),
        (isShowMore750.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["rightButtom", selectedArray.value.length > 0 ? '' : 'opacityDiv'])
            }, [
              _withDirectives(_createElementVNode("div", {
                class: "buttomItem pointer",
                style: {"margin-right":"16px"},
                onClick: downloadZip
              }, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep200.Download')), 1)
              ], 512), [
                [_vShow, !downloadLoading.value]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_11, _hoisted_13, 512), [
                [_vShow, downloadLoading.value]
              ]),
              (!deviceType.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["buttomItem pointer", isVibe.value ? 'demoStyle' : '']),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (isShowDia.value = true))
                  }, [
                    _hoisted_14,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep200.Delete')), 1)
                  ], 2))
                : _createCommentVNode("", true)
            ], 2))
          : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
              _withDirectives(_createElementVNode("div", {
                class: "buttomItem pointer",
                style: {"margin-right":"16px"},
                onClick: downloadZip
              }, [
                _hoisted_16,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep200.Download')), 1)
              ], 512), [
                [_vShow, !downloadLoading.value]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_17, _hoisted_19, 512), [
                [_vShow, downloadLoading.value]
              ]),
              (!deviceType.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["buttomItem pointer", isVibe.value ? 'demoStyle' : '']),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (isShowDia.value = true))
                  }, [
                    _hoisted_20,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('famikeep200.Delete')), 1)
                  ], 2))
                : _createCommentVNode("", true)
            ], 512)), [
              [_vShow, selectedArray.value.length > 0]
            ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        (photoLoading.value)
          ? (_openBlock(), _createBlock(loading, {
              key: 0,
              class: "loading"
            }))
          : ((photoListArray.value.length > 0 && selectedTagName.value == 1) || (albumList.value.length > 0 && selectedTagName.value == 2 && !albumPhoto.value) || (photoListArray.value.length > 0 && selectedTagName.value == 2 && albumPhoto.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("section", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photoListArray.value, (photoDays, index) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_el_checkbox, {
                            class: "checkBox",
                            modelValue: photoDays[1],
                            "onUpdate:modelValue": ($event: any) => ((photoDays[1]) = $event),
                            onChange: ($event: any) => (selectDayAll(photoDays))
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                          _createElementVNode("span", null, _toDisplayString(photoDays[0]), 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photoDays[2], (item, index1) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createVNode(_component_el_image, {
                                class: "itemPhoto",
                                src: item.thumb_url ? item.thumb_url : item.origin_url,
                                "initial-index": currentPreviewIndex.value,
                                ref_for: true,
                                ref: "previewImg",
                                onClick: ($event: any) => (openPreview(item.thumb_url ? (isVibe.value ? item.origin_url : item.thumb_url) : item.origin_url)),
                                "preview-src-list": previewImgList.value,
                                fit: "contain",
                                "hide-on-click-modal": true
                              }, null, 8, ["src", "initial-index", "onClick", "preview-src-list"]),
                              _createElementVNode("div", {
                                class: "hover-area",
                                style: _normalizeStyle({ 'opacity': item.isSelect ? '1' : '' })
                              }, [
                                _createElementVNode("div", _hoisted_29, [
                                  _createVNode(_component_el_checkbox, {
                                    class: "checkBox",
                                    modelValue: item.isSelect,
                                    "onUpdate:modelValue": ($event: any) => ((item.isSelect) = $event),
                                    onChange: ($event: any) => (changeCheckBoxStaus(item, photoListArray.value[index]))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                                  _createElementVNode("span", null, _toDisplayString(item.dateYMD), 1)
                                ]),
                                _createElementVNode("img", {
                                  src: _imports_5,
                                  alt: "",
                                  class: "pointer",
                                  onClick: ($event: any) => (downloadItem(item.download_url ? item.download_url : item.origin_url))
                                }, null, 8, _hoisted_30)
                              ], 4)
                            ]))
                          }), 256))
                        ])
                      ]))
                    }), 256))
                  ], 512), [
                    [_vShow, selectedTagName.value == 1 || (selectedTagName.value == 2 && albumPhoto.value)]
                  ]),
                  _withDirectives(_createElementVNode("section", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(albumList.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("img", {
                              src: _imports_1,
                              alt: "",
                              class: "pointer",
                              onClick: ($event: any) => (goAlbumPhoto(item))
                            }, null, 8, _hoisted_35)
                          ]),
                          _createElementVNode("span", _hoisted_36, [
                            _createVNode(Tooltip, {
                              content: item.iosname ? item.iosname : item.name
                            }, null, 8, ["content"])
                          ]),
                          _createElementVNode("span", _hoisted_37, _toDisplayString(item.count), 1)
                        ]))
                      }), 256))
                    ])
                  ], 512), [
                    [_vShow, selectedTagName.value == 2 && !albumPhoto.value]
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
              ])),
        _withDirectives(_createElementVNode("div", _hoisted_41, [
          _withDirectives(_createElementVNode("div", {
            class: "backArrow pointer",
            onClick: goBackAlbum
          }, [
            _hoisted_42,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("famikeep200.Back")), 1)
          ], 512), [
            [_vShow, selectedTagName.value == 2 && albumPhoto.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_43, [
            _createVNode(_component_el_pagination, {
              background: "",
              layout: "prev, pager, next",
              total: totalNum.value,
              onSizeChange: handleSizeChange,
              "page-size": 20,
              onCurrentChange: handleCurrentChange,
              "current-page": currentPage.value
            }, null, 8, ["total", "current-page"])
          ], 512), [
            [_vShow, ((selectedTagName.value == 1 && totalNum.value > 0) || (selectedTagName.value == 2 && albumPhoto.value && totalNum.value > 0))]
          ])
        ], 512), [
          [_vShow, ((selectedTagName.value == 1 && totalNum.value > 0) || (selectedTagName.value == 2 && albumPhoto.value))]
        ])
      ])
    ]),
    (isShowDia.value)
      ? (_openBlock(), _createBlock(changeCancel, {
          key: 0,
          visible: isShowDia.value,
          showTitle: false,
          showclose: false,
          width: 480,
          info: _ctx.$t('famikeep200.confirm to delete'),
          onConfirm: _cache[5] || (_cache[5] = ($event: any) => (isShowDia.value = false)),
          onCancle: deletePhotoFun,
          Cancel: _ctx.$t('pop.yes'),
          Okay: _ctx.$t('famikeep200.Back')
        }, null, 8, ["visible", "info", "Cancel", "Okay"]))
      : _createCommentVNode("", true)
  ]))
}
}

})